<template>
  <div class="row w-100">
    <div class="card w-100">
      <div class="card-header">
        <div class="w-100 d-flex justify-content-between">
          <h5>#{{ sell.id }} ({{ statuToTxt(sell.status_payment) }}) - {{ sell.course.name }} - {{ sell.user.name }} - {{ sell.buyed_at }}</h5>
          <div>
            <button
              class="btn btn-sm btn-primary"
              type="button"
              data-toggle="collapse"
              :data-target="`#sell-${ sell.id }`"
              aria-expanded="false"
              :aria-controls="`sell-${ sell.id }`"
            >
              <i class="fa fa-plus-circle"></i>
            </button>
          </div>
        </div>
      </div>


      <div :id="`sell-${ sell.id }`" class="card-body col-12 collapse">
        <div class="row">
          <h5 class="col-12">Comprador</h5>
          <div class="col-12 col-md-2 border-bottom">
            <small><b>ID</b></small>
            <p class="mb-0">{{ sell.user.id }}</p>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <small><b>Nome</b></small>
            <p class="mb-0">{{ sell.user.name }}</p>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <small><b>Email</b></small>
            <p class="mb-0">{{ sell.user.email }}</p>
          </div>

          <div class="col-12 col-md-2 border-bottom">
            <small><b>CPF/CNPJ</b></small>
            <p class="mb-0">{{ sell.user.document }}</p>
          </div>

          <h5 class="col-12 mt-3">Curso</h5>
          <div class="col-12 col-md-2 border-bottom">
            <small><b>ID</b></small>
            <p class="mb-0">{{ sell.course.id }}</p>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <small><b>Email</b></small>
            <p class="mb-0">{{ sell.course.name }}</p>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <small><b>Professor</b></small>
            <p class="mb-0">{{ sell.course.user.name }}</p>
          </div>

          <div class="col-12 col-md-2 border-bottom">
            <small><b>Valor</b></small>
            <p class="mb-0">{{ sell.course.value| formatMoney }}</p>
          </div>


          <h5 class="col-12 mt-3">Detalhes da Compra</h5>
          <div class="col-12 col-md-2 border-bottom">
            <small><b>ID</b></small>
            <p class="mb-0">{{ sell.id }}</p>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <label><small><b>Forma de Pagamento</b></small></label>
            <select
              v-model="sell.payment_form"
              class="form-control form-control-sm custom-select custom-select-sm"
              :disabled="loading"
            >
              <option value="blt">Boleto</option>
              <option value="ccr">Cartão de Crédito</option>
              <option value="FR">Gratis</option>
              <option value="add">Adicionado Manualmente</option>
            </select>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <label><small><b>Valor Pago</b></small></label>
            <money class="form-control form-control-sm" v-model="sell.value" :disabled="loading"/>
          </div>

          <div class="col-12 col-md-2 border-bottom">
            <label><small><b>Parcelas</b></small></label>
            <span class="input-group input-group-sm">
              <input
                type="number"
                min="1"
                max="12"
                class="form-control form-control-sm"
                v-model="sell.quotas"
                :disabled="loading"
              />
              <span class="input-group-append">
                <span class="input-group-text">x</span>
              </span>
            </span>
          </div>

          <div class="col-12 col-md-2 border-bottom">
            <label><small><b>Comprado em</b></small></label>
            <input
              type="datetime-local"
              class="form-control form-control-sm"
              v-model="buyedAtDate"
              :disabled="loading"
            />
          </div>

          <div class="col-12 col-md-2 border-bottom">
            <label><small><b>Pago em</b></small></label>
            <input
              type="datetime-local"
              class="form-control form-control-sm"
              v-model="payedAtDate"
              :disabled="loading"
            />
          </div>

          <div class="col-12 col-md-6 border-bottom">
            <label><small><b>Link de Acesso</b></small></label>
            <input
              class="form-control form-control-sm"
              v-model="sell.user_link"
              :disabled="loading"
            />
          </div>

          <div class="col-12 col-md-2 border-bottom">
            <label><small><b>Status do Pagamento</b></small></label>
            <p class="mb-0">{{ statuToTxt(sell.status_payment) }}</p>
          </div>

          <div class="col-12 col-md-3 border-bottom">
            <label><small><b>Marketplace ID</b></small></label>
            <p class="mb-0">{{ sell.payment_id }}</p>
          </div>

          <div class="col-12 col-md-3 border-bottom">
            <small><b>Marketplace Detalhes</b></small>
            <p class="mb-0">{{ sell.transaction_details }}</p>
          </div>

          <div class="col-12 col-md-3 border-bottom">
            <small><b>Marketplace Tipo</b></small>
            <p class="mb-0">{{ sell.mp_type }}</p>
          </div>

          <div class="col-12 col-md-3 border-bottom">
            <small><b>Marketplace Link</b></small><br>
            <div
              style="cursor:pointer;"
              class="mb-0 clickable badge badge-info badge-pill p-2"
              @click="openDetails(sell.payment_id, sell.course.user.token)"
            >
              <b>
                <span v-if="generatingUrl">
                  <i class="fa fa-fw fa-spin fa-spinner"></i>
                </span>{{ sell.payment_id }}
              </b>
            </div>
          </div>

          <div class="col-12 col-md-3 border-bottom">
            <small><b>Acessível</b></small>
            <div class="input-group">
              <select
                class="form-control form-control-sm custom-select custom-select-sm"
                v-model="sell.is_accessable"
                :disabled="loading"
              >
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>

              <span class="input-group-append">
                <button
                  class="input-group-text"
                  @click="saveAccessibility"
                  :disabled="loading"
                ><i class="fa fa-check-circle"/></button>
              </span>
            </div>
          </div>

          <div class="col-12 col-md-9 text-right">
            <button class="btn btn-success mt-3" :disabled="loading" @click="saveSell">
              <span v-if="loading">
                <i class="fa fa-spin fa-spinner"/>
              </span>
              Salvar Alterações
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  props: {
    sell: {
      required: true
    }
  },
  data () {
    return {
      loading: false,
      generatingUrl: false,
    }
  },
  computed: {
    payedAtDate: {
      get () {
        if(!this.sell.payed_at) return undefined;
        return this.sell.payed_at.split(' ').join('T');
      },
      set (value) {
        this.sell.payed_at = value.split('T').join(' ');
      }
    },
    buyedAtDate: {
      get () {
        if(!this.sell.buyed_at) return undefined;
        console.log(this.sell.buyed_at.split(' ').join('T'))
        return this.sell.buyed_at.split(' ').join('T');
      },
      set (value) {
        this.sell.buyed_at = value.split('T').join(' ');
      }
    }
  },
  methods: {
    openDetails(payment, accessToken) {
      this.generatingUrl = true
      Axios.get(`https://api.iugu.com/v1/invoices/${payment}?api_token=${accessToken}`)
        .then(res => {
          console.log( res )
          window.open(res.data.secure_url, '_blank')
        })
        .catch( err => console.error(err))
        .then(() => this.generatingUrl = false)
    },
    statuToTxt: function (item) {
      switch (item) {
        case 'P':
          return 'Processando';
        case 'W':
          return 'Aguardando';
        case 'S':
          return 'Aprovado';
        case 'E':
          return 'Erro';
        default:
          break;
      }
    },
    saveAccessibility: function () {
      this.loading = true
      Axios.post('/teacher/my/courses/sells/change', {
        id: this.sell.id,
        is_accessable: this.sell.is_accessable
      })
        .then( res => {
          console.log( res )
        })
        .catch( err => {
          console.error( err )
        })
        .then( () => {
          this.loading = false
        })
    },
    saveSell: function() {
      this.loading = true

      Axios.post('/admin/sells/edit', {
        id: this.sell.id,
        payment_form: this.sell.payment_form,
        value: this.sell.value,
        quotas: this.sell.quotas,
        buyed_at: this.sell.buyed_at,
        payed_at: this.sell.payed_at,
        is_accessable: this.sell.is_accessable,
        user_link: this.sell.user_link,
      })
        .then( res => {
          console.log( res )
        })
        .catch( err => {
          console.error( err )
        })
        .then( () => {
          this.loading = false
        })
    }
  }
}
</script>
